import type { ColumnType } from 'antd/lib/table';
import { TFunction } from 'i18next';

export const peopleCountColumn = <T extends { peopleCount: number }>(
  t: TFunction,
): ColumnType<T> => ({
    title: t('People count'),
    dataIndex: 'peopleCount',
  });
